import { render } from "./recipient-inputs.vue?vue&type=template&id=6bb3d7c2&lang=pug"
import script from "./recipient-inputs.vue?vue&type=script&setup=true&lang=js"
export * from "./recipient-inputs.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__